import { jsx as _jsx } from "react/jsx-runtime";
import styles from './styles.module.scss';
const TjenestepanelContainerProps = props => {
    return (_jsx("div", { className: styles.tjenestepanelcontainer, "data-testid": "tjenestepanel", children: _jsx("div", { className: "container", children: _jsx("div", { className: "row", children: _jsx("div", { className: "col", children: props.children }) }) }) }));
};
export default TjenestepanelContainerProps;
